import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function KPI({ icon: Icon, label, value, sub, color = "text-slate-700 bg-slate-50", testId }) {
  return (
    <Card className="p-4 hover:shadow-md transition-shadow" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className={`w-9 h-9 rounded ${color} flex items-center justify-center`}>
          <Icon className="w-4 h-4" />
        </div>
        {sub && <Badge variant="outline" className="text-[10px]">{sub}</Badge>}
      </div>
      <div className="text-2xl font-black tracking-tight text-slate-900 mt-3 tabular-nums">{value ?? "—"}</div>
      <div className="text-[10px] uppercase tracking-widest font-semibold text-slate-500 mt-1">{label}</div>
    </Card>
  );
}

export function Panel({ title, action, children, testId }) {
  return (
    <Card className="p-5" data-testid={testId}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-slate-900">{title}</h3>
        {action}
      </div>
      {children}
    </Card>
  );
}

export function EmptyRow({ text = "Nothing here yet" }) {
  return <div className="text-center py-6 text-xs text-slate-400">{text}</div>;
}
